import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare var jQuery: any;
declare var async: any;

@Injectable()
export class AuthenticationService {

	

	constructor() {
		
	}

	public get loginUrl(): string {
      return null;//return this.keycloak.createLoginUrl();
	}

    public logoutUrl(): string {
        //const str = this.keycloak.createLogoutUrl();
        ////console.log(str);
      return null;// return str;
	}

	public get registerUrl(): string {
      return null;//return this.keycloak.createRegisterUrl();
	}

	public get accountManagementUrl(): string {
      return null;//return this.keycloak.createAccountUrl();
	}

	public get authenticated(): boolean {
      return null;//return this.keycloak.authenticated;
	}

	//public get userId(): string {
	//	return this.keycloak.subject;
	//}

	//public get userProfile(): string {
	//	return this.keycloak.profile;
	//}

	//public get userInfo(): string {
	//	return this.keycloak.userInfo;
	//}

	public get userData(): any {
      return null;//return environment.authWebApi.userData;
	}

	public get token(): string {
      return null;//return this.keycloak.token;
	}

	public get tokenContent(): string {
      return null;//this.keycloak.tokenParsed;
	}

	//actions

	public login() {
      return null;//return this.keycloak.login();
	}

	public logout() {
      return null;//return this.keycloak.logout();
	}

	public register() {
      return null;//return this.keycloak.register();
	}

	public accountManagement() {
      return null;//return this.keycloak.accountManagement();
	}

	
}
